module.exports = __webpack_public_path__ + "static/media/mongodb.e5eee315.png";